import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { Expense } from 'src/app/commons/models/expense.model';
import { PAGE_SIZE_OPTIONS } from 'src/app/helpers/table.helper';
import * as ExpenseActions from 'src/app/store/actions/expense.actions';
import { AppState } from 'src/app/store/reducers';
import * as ExpenseSelectors from 'src/app/store/selectors/expense.selectors';

import { ExpenseFilters } from '../../../commons/models/expense.model';
import { ExpensesColumn } from '../expense-list/expense-list.component';

@Component({
  selector: 'app-expense-selection',
  templateUrl: './expense-selection.component.html',
  styleUrls: ['./expense-selection.component.scss'],
})
export class ExpenseSelectionComponent implements OnInit {
  private unsubscribe$ = new Subject<void>();

  expenses: Observable<Expense[]>;
  filters: Observable<ExpenseFilters>;

  @Input()
  defaultFilters: ExpenseFilters = {
    search: '',
  };

  displayedColumns: ExpensesColumn[] = [
    'id',
    'project',
    'user',
    'amount',
    'actions',
  ];

  pageSizeOptions = PAGE_SIZE_OPTIONS;

  total: Observable<number>;
  private _includes: string[] = [
    'professional',
    'billing_line',
    'cost_line',
    'validation_user',
  ];
  constructor(
    private store$: Store<AppState>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.expenses = this.store$.pipe(
      select(ExpenseSelectors.getExpenses),
      takeUntil(this.unsubscribe$),
      map((dtos) => (dtos ? dtos.map((dto) => new Expense(dto)) : null))
    );
    this.total = this.store$.pipe(
      select(ExpenseSelectors.getTotalExpenses),
      takeUntil(this.unsubscribe$)
    );
    this.filters = this.store$.pipe(
      select(ExpenseSelectors.getFilters),
      takeUntil(this.unsubscribe$)
    );
    if (data) {
      this.defaultFilters = data.defaultFilters;
    }
  }

  load() {
    this.store$.dispatch(
      ExpenseActions.loadExpenses({
        page: 1,
        perPage: this.pageSizeOptions[0],
        filters: this.defaultFilters,
        includes: this._includes,
      })
    );
  }

  sortChange(sort: Sort) {
    this.store$.dispatch(
      ExpenseActions.changeSort({
        order: sort.active,
        direction: sort.direction,
      })
    );
  }

  pageChange(pageEvent: PageEvent) {
    this.store$.dispatch(
      ExpenseActions.changePage({
        page: pageEvent.pageIndex + 1,
        size: pageEvent.pageSize,
      })
    );
  }

  filtersChange(filters: ExpenseFilters) {
    this.store$.dispatch(ExpenseActions.changeFilters({ filters }));
  }

  ngOnInit() {
    this.load();
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  selectExpense(expense: Expense) {
    if (expense) {
      this.store$.dispatch(
        ExpenseActions.expenseSelected({ expense: expense.toDTO() })
      );
    }
  }

  close() {
    this.store$.dispatch(ExpenseActions.closeSelectionDialog());
  }
}
